import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  AppSuiteUser,
  PersonalTask,
  useGetUsersQuery,
} from "graphql/generated/schema-types";
import { useGetUsersById } from "hooks/cacheAccessHooks";
import React, { ChangeEvent, useState } from "react";

interface AssignToUsersProps {
  isOpen: boolean;
  handleClose: (assignedUsers: number[], assignUsers: boolean) => void;
  selectedTask: PersonalTask;
}

export const AssignToUsersDialog = ({
  isOpen,
  handleClose,
  selectedTask,
}: AssignToUsersProps) => {
  const usersQuery = useGetUsersQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
  });

  const assignedUsers = useGetUsersById(
    (selectedTask?.users ?? [])
      .map((user) => user?.userId)
      .filter((userId): userId is number => userId != null),
  );
  const [selectedUsers, setSelectedUsers] = useState<AppSuiteUser[] | null>(
    null,
  );
  const displayedUsers = selectedUsers ?? assignedUsers ?? [];

  const handleUsersChanged = (e: ChangeEvent<unknown>, value: any) => {
    setSelectedUsers(value ?? []);
  };

  const handleSubmit = () => {
    const userIds = displayedUsers
      .map((user) => user?.userId)
      .filter((userId): userId is number => userId != null);
    handleClose(userIds, true);
  };

  const clearSelectedUsers = () => {
    setSelectedUsers(null);
    handleClose([], false);
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => clearSelectedUsers()}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Assign Tasks to User(s)</DialogTitle>
        <DialogContent>
          <ul>
            <li>{selectedTask.taskName}</li>
          </ul>
          <Autocomplete
            multiple
            id="tags-outlined"
            options={usersQuery.data?.appSuiteUsers?.map((node) => node) ?? []}
            getOptionLabel={(option) => option!.userName!}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
            onChange={(event: ChangeEvent<unknown>, newValue: any) =>
              handleUsersChanged(event, newValue)
            }
            value={displayedUsers}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
